// extracted by mini-css-extract-plugin
module.exports = {"simpleHotWrapperControls":"SimpleHotWrapperControls_simpleHotWrapperControls__3kpvo"};